import React from 'react';
import * as types from './stepTypes';
import TextControl from './controls/textControl';
import ButtonControl from './controls/buttonControl';
import DropDown from './controls/dropDown';
import RadioList from './controls/radioList';
import Range from './controls/range';
import MultiPart from './controls/multiPartControlRrf';
import CheckBoxes from './controls/checkBoxes';
import PropTypes from 'prop-types';
import Interstitial from './controls/interstitial';
import LabelNode from './controls/labelNode';
import LazyComponentWrapper from '../common/LazyComponentWrapper';
import { lazyWithRetry } from '../../utils/lazyWithRetry';

const ComboBox = lazyWithRetry(
  () => import(/* webpackChunkName: "combobox" */ './controls/comboBox'),
  'combobox'
);
const NativeDatePicker = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "datepicker" */ './controls/nativeDatePickerRrf'
    ),
  'datepicker'
);
const Uploader = lazyWithRetry(
  () => import(/* webpackChunkName: "uploader" */ './controls/DocumentUpload'),
  'uploader'
);
const VehicleMake = lazyWithRetry(
  () => import(/* webpackChunkName: "vehicle-flow" */ './controls/vehicleMake'),
  'vehicle-flow'
);
const VehicleModel = lazyWithRetry(
  () =>
    import(/* webpackChunkName: "vehicle-flow" */ './controls/vehicleModel'),
  'vehicle-flow'
);
const VehicleTrim = lazyWithRetry(
  () => import(/* webpackChunkName: "vehicle-flow" */ './controls/vehicleTrim'),
  'vehicle-flow'
);
const ProductSelection = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "product-selection" */ './controls/productSelection'
    ),
  'product-selection'
);
const ComponentWrapper = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "component-wrapper" */ '../dynamicComponents/componentWrapper'
    ),
  'component-wrapper'
);
const VerifiedServiceOtpInput = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "otp-input" */ './controls/verifiedServiceOtpInput'
    ),
  'otp-input'
);

const StepsComposer = (props) => {
  switch (props.step.nodetype) {
    case types.FORM_TEXT:
      return <TextControl {...props} />;
    case types.FORM_SELECT:
      return <DropDown {...props} />;
    case types.FORM_RADIO:
      return props.step.optionclickable ? (
        <Interstitial {...props} />
      ) : (
        <RadioList {...props} />
      );
    case types.FORM_COMBOBOX:
      return (
        <LazyComponentWrapper
          source="StepsComposer:ComboBox"
          component={ComboBox}
          componentProps={props}
        />
      );
    case types.FORM_RANGE:
      return <Range {...props} />;
    case types.FORM_MULTIPART:
      return <MultiPart {...props} />;
    case types.FORM_DATE_NATIVE_DATE_PICKER:
      return (
        <LazyComponentWrapper
          source="StepsComposer:NativeDatePicker"
          component={NativeDatePicker}
          componentProps={props}
        />
      );
    case types.FORM_UPLOAD:
      return (
        <LazyComponentWrapper
          source="StepsComposer:Uploader"
          component={Uploader}
          componentProps={props}
        />
      );
    case types.FORM_CHECKBOXES:
    case types.FORM_TOGGLE:
      return <CheckBoxes {...props} />;
    case types.FORM_BUTTON:
      return <ButtonControl {...props} />;
    case types.PRODUCT_SELECTION:
      return (
        <LazyComponentWrapper
          source="StepsComposer:ProductSelection"
          component={ProductSelection}
          componentProps={props}
        />
      );
    case types.LABEL_NODE:
      return <LabelNode {...props} />;
    case types.FORM_VEHICLE_MAKE:
      return (
        <LazyComponentWrapper
          source="StepsComposer:VehicleMake"
          component={VehicleMake}
          componentProps={props}
        />
      );
    case types.FORM_VEHICLE_MODEL:
      return (
        <LazyComponentWrapper
          source="StepsComposer:VehicleModel"
          component={VehicleModel}
          componentProps={props}
        />
      );
    case types.FORM_VEHICLE_TRIM:
      return (
        <LazyComponentWrapper
          source="StepsComposer:VehicleTrim"
          component={VehicleTrim}
          componentProps={props}
        />
      );
    case types.FORM_COMPONENT:
      return (
        <LazyComponentWrapper
          source="StepsComposer:ComponentWrapper"
          component={ComponentWrapper}
          componentProps={props}
        />
      );
    case types.FORM_VERIFIED_SERVICE_OTP:
      return (
        <LazyComponentWrapper
          source="StepsComposer:VerifiedServiceOtpInput"
          component={VerifiedServiceOtpInput}
          componentProps={props}
        />
      );
    default:
      return null;
  }
};

StepsComposer.propTypes = {
  steps: PropTypes.array,
  modelParser: PropTypes.func,
  formatter: PropTypes.func,
  step: PropTypes.object,
  handleNext: PropTypes.func,
};

export default StepsComposer;
